export function clearMarkdownAndHTMLAndTrim(text: string, maxLength = 200) {
	const withoutHtml = text.replace(/<\/?[^>]+(>|$)/g, " ");
	const plainText = withoutHtml.replace(/([*#_~`>!\[\]()])/g, "").replace(/(\r\n|\n|\r)/g, " ");

	return plainText.length > maxLength ? plainText.slice(0, maxLength) + "..." : plainText;
}
